export function CreativeVariants({ creative, onPick }) {
  if (!creative?.headlines?.length && !creative?.hooks?.length) return null;
  const Group = ({ title, items, field, testId }) => items?.length ? (
    <div data-testid={testId}>
      <div className="text-[11px] uppercase tracking-wider text-slate-400 font-semibold mb-1.5">{title}</div>
      <div className="flex flex-wrap gap-2">
        {items.map((x, i) => (
          <button key={i} type="button" onClick={() => onPick({ [field]: x })}
            className={`text-left text-xs px-3 py-1.5 rounded-lg border transition-colors ${creative[field] === x ? "border-cyan-400/50 bg-cyan-500/10 text-cyan-100" : "border-white/10 text-slate-300 hover:border-white/25"}`}
            data-testid={`${testId}-${i}`}>{x}</button>
        ))}
      </div>
    </div>
  ) : null;
  return (
    <div className="nadia-card p-4 space-y-3" data-testid="creative-variants">
      <div className="text-xs text-slate-400">Varianti proposte da Nadia per il test: tocca per usarla nell'annuncio.{creative.hypothesis && <span className="block mt-1 text-slate-500">Ipotesi in test: {creative.hypothesis}</span>}</div>
      <Group title="Hook" items={creative.hooks} field="hook" testId="variant-hook" />
      <Group title="Headline" items={creative.headlines} field="headline" testId="variant-headline" />
      <Group title="Testo principale" items={creative.primary_texts} field="primary_text" testId="variant-copy" />
      {creative.creative_concepts?.length > 0 && (
        <div data-testid="creative-concepts">
          <div className="text-[11px] uppercase tracking-wider text-slate-400 font-semibold mb-1.5">Concept creativi</div>
          <ul className="space-y-1 text-xs text-slate-300">{creative.creative_concepts.map((c, i) => <li key={i}><span className="text-white font-semibold">{c.name}</span> · {c.visual_hook} · {c.format} {c.platform} — {c.why}</li>)}</ul>
        </div>
      )}
    </div>
  );
}
